import React from "react";
import "./ContactUs.css";
import Topbar from "../../Components/Topbar/Topbar";
import Navbar from "../../Components/Navbar/Navbar";
import GetInTouch from "../Home/Components/GetInTouch/GetInTouch";
import Footer from "../../Components/Footer/Footer";
import Banner2 from "../../Components/Banner/Banner2";
import ContactForm from "./Components/ContactForm/ContactForm";
import ContactInfo from "./Components/ContactInfo/ContactInfo";
import OurLocation from "./Components/OurLocation/OurLocation";
const ContactUs = () => {
  return (
    <div className="contactus__screen">
      <Topbar />
      <Navbar />
      <Banner2 heading="ContactUs" />
      <ContactForm />
      <ContactInfo />
      {/* <OurLocation /> */}
      <GetInTouch />
      <Footer />
    </div>
  );
};

export default ContactUs;
